<template src="./ViewRenuncia.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Divider} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {requestRenunciaMixin} from "@/api/ciudadano/renunciaApi";
import RenunciaDetail from "@/components/Shared/RenunciaDetail/RenunciaDetail";

export default {
  name: "ViewRenuncia",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    RenunciaDetail
  },
  mixins: [
    ScreenSizeMixin,
    requestRenunciaMixin,
    NotifyMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    inRoute: false,
    model: {
      id: "",
      rut: "",
      nombreCompleto: "",
      domicilio: "",
      fechaNacimiento: '',
      email: "",
      telefonoMovil: "",
      telefonoFijo: "",
      estado: "",
      estadoCodigo: 0,
      fecha: '',
      hora: ''
    },
  }),
  props: {
    id: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getId()
    this.renuncia()
  },
  computed: {
    getShadow: function () {
      if (this.$route.params.hasOwnProperty('id')) {
        return 'always'
      }
      return 'never'
    }
  },
  methods: {
    getId() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
      } else {
        this.model.id = this.id
      }
    },
    renuncia() {
      this.getRenunciaVer(this.model.id)
        .then(response => {
          this.$log.debug('getRenunciaVer', this.model.id, response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.convertDataToModel(data)

            this.errored = false
          } else {
            this.messageError(response.data.statusCode)
          }
        })
        .catch(err => {
          this.$log.fatal('getRenunciaVer', err, this.model.id)
          this.messageError(err.request.status)
        })
        .finally(() => {
          this.loading = false
        })
    },
    convertDataToModel(data = {}) {
      this.model.rut = data.cedula
      this.model.nombreCompleto = data.nombrecompleto
      this.model.fechaNacimiento = moment(data.fechanacimiento, "YYYYMMDD").format('DD-MM-YYYY')
      this.model.email = data.email;
      this.model.telefonoMovil = data.telefonomovil
      this.model.telefonoFijo = data.telefonofijo
      this.model.estado = data.estado
      this.model.estadoCodigo = data.estadocodigo

      const mfecha = moment.utc(data.fecha).local()
      this.model.fecha = mfecha.format('DD-MM-YYYY')
      this.model.hora = mfecha.format('h:mm a')
      this.model.domicilio = data.domicilio

      this.model.partidosSeleccionado = data.partidonombre
    },
    messageError(statusCode) {
      this.errored = true
      let message = 'Ocurrió un error inesperado al cargar la renuncia'
      if (statusCode === 404) {
        message = 'La renuncia no existe'
      }
      this.showError(message)
      this.$emit('on-error-close', true)
    },
  }
}
</script>
